/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_LabelInputs */

const en_blog_filter_label = /** @type {(inputs: Blog_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter articles`)
};

const lv_blog_filter_label = /** @type {(inputs: Blog_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrēt rakstus`)
};

/**
* | output |
* | --- |
* | "Filter articles" |
*
* @param {Blog_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_filter_label = /** @type {((inputs?: Blog_Filter_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_filter_label(inputs)
	return en_blog_filter_label(inputs)
});